<template>
  <div class="bg-light py-5 min-vh-100">
    <div class="container">
      <div class="row justify-content-center text-left">
        <div class="col-lg-10">
          <div class="card shadow-sm border-0 rounded-lg overflow-hidden">
            <div
              class="header-image d-flex align-items-end p-2 text-white"
              :style="{
                backgroundImage: ` url('https://baessh.com.mx/img/email/gridencuesta.webp')`,
              }"
            ></div>

            <div class="card-body p-4 p-md-5">
              <h1 class="display-5 font-weight-bold mb-3">
                Formulario de Satisfacción del Cliente
              </h1>
              <p class="text-muted mb-5">
                En BAESSH nos preocupamos por brindar un seguimiento y atención
                al trabajo que le proporcionamos. Esta encuesta es una
                herramienta que nos permite medir la eficiencia de los servicios
                e identificar oportunidades de mejora. Su opinión es muy
                importante para nosotros.<br /><br />
                <b>PARA ATENCIÓN A QUEJAS, COMUNICATE AL:</b> Correo:
                contacto@baessh.com.mx Tel: 667 713 8632 y 667 751 1676 A través
                de nuestra página web: www.baessh.com.mx
              </p>

              <form @submit.prevent="enviarEncuesta">
                <section class="mb-5">
                  <h3
                    class="h5 font-weight-bold mb-4 border-left-primary-custom pl-3"
                  >
                    Datos Generales
                  </h3>
                  <div class="form-row">
                    <div class="form-group col-md-4">
                      <p class="font-weight-bold">Empresa</p>
                      <input
                        v-model="form.empresa"
                        type="text"
                        class="form-control"
                        placeholder="Nombre de su empresa"
                        required
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <p class="font-weight-bold">Nombre</p>
                      <input
                        v-model="form.nombre"
                        type="text"
                        class="form-control"
                        placeholder="Su nombre completo"
                        required
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <p class="font-weight-bold">Puesto</p>
                      <input
                        v-model="form.puesto"
                        type="text"
                        class="form-control"
                        placeholder="Su cargo actual"
                        required
                      />
                    </div>
                  </div>
                </section>

                <section class="mb-5">
                  <h3
                    class="h5 font-weight-bold mb-4 border-left-primary-custom pl-3"
                  >
                    Servicios Evaluados
                  </h3>
                  <div class="form-group">
                    <p class="font-weight-bold">
                      Seleccione los servicios proporcionados:
                    </p>

                    <div class="row">
                      <div
                        v-for="opcion in opcionesServicio"
                        :key="opcion.id"
                        class="col-md-6 mb-2"
                      >
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            :id="'check-' + opcion.id"
                            :value="opcion.id"
                            v-model="form.servicio_evaluado"
                            class="custom-control-input"
                          />
                          <label
                            class="custom-control-label"
                            :for="'check-' + opcion.id"
                          >
                            {{ opcion.nombre }}
                          </label>
                        </div>
                      </div>
                    </div>

                    <small
                      v-if="showErrors && form.servicio_evaluado.length === 0"
                      class="text-danger"
                      ref="errorServicios"
                    >
                      * Seleccione al menos un servicio.
                    </small>
                  </div>
                </section>
                <section v-if="showPortalExperience" class="mb-5">
                  <h3
                    class="h5 font-weight-bold mb-4 border-left-primary-custom pl-3"
                  >
                    Portal de Clientes BAESSH
                  </h3>
                  <div class="form-group mb-4">
                    <p class="font-weight-bold">
                      ¿Cómo calificarías tu experiencia utilizando nuestra
                      plataforma digital (Portal de Clientes BAESSH) durante el
                      trámite de tu Programa Interno?
                    </p>
                    <div class="rating-group">
                      <div
                        v-for="(option, idx) in portalExperienceOptions"
                        :key="'portal-exp-' + idx"
                        class="rating-option"
                      >
                        <input
                          type="radio"
                          :id="'portal-exp-' + idx"
                          name="portal_experiencia"
                          v-model="form.portal_experiencia"
                          :value="idx + 1"
                          class="rating-input"
                          :required="showPortalExperience"
                        />
                        <label
                          class="rating-label"
                          :for="'portal-exp-' + idx"
                        >
                          <i :class="option.icon" class="rating-icon"></i>
                          {{ option.label }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <p class="font-weight-bold">
                      ¿Qué mejorarías de nuestra plataforma digital? (opcional)
                    </p>
                    <textarea
                      v-model="form.portal_experiencia_comentarios"
                      class="form-control"
                      rows="3"
                      maxlength="255"
                      placeholder="Escriba aquí sus sugerencias..."
                    ></textarea>
                  </div>
                </section>
                <section class="mb-5">
                  <h3
                    class="h5 font-weight-bold mb-4 border-left-primary-custom pl-3"
                  >
                    Evaluación del Servicio
                  </h3>
                  <div class="table-responsive rounded border">
                    <table class="table table-hover mb-0 text-center">
                      <thead class="thead-light">
                        <tr>
                          <th class="text-left py-3" style="min-width: 250px">
                            Aspectos a evaluar
                          </th>
                          <th
                            v-for="label in labelsRating"
                            :key="label"
                            class="py-3"
                          >
                            {{ label }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(label, key) in aspectos" :key="key">
                          <td
                            class="text-left font-weight-medium align-middle py-3"
                          >
                            {{ label }}
                          </td>
                          <td v-for="n in 5" :key="n" class="align-middle">
                            <div class="custom-control custom-radio">
                              <input
                                type="radio"
                                :id="key + n"
                                :name="key"
                                :value="n"
                                v-model="form['rating_' + key]"
                                class="custom-control-input"
                                required
                              />
                              <label
                                class="custom-control-label"
                                :for="key + n"
                              ></label>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </section>

                <section class="mb-5">
                  <h3
                    class="h5 font-weight-bold mb-4 border-left-primary-custom pl-3"
                  >
                    Comentarios Adicionales
                  </h3>

                  <div class="form-group mb-4">
                    <p class="font-weight-bold d-block">
                      ¿Recomendaría nuestros servicios?
                    </p>
                    <div
                      class="custom-control custom-radio custom-control-inline"
                    >
                      <input
                        type="radio"
                        id="recomendarSi"
                        name="recomendar_servicio"
                        v-model="form.recomienda_servicio"
                        :value="true"
                        class="custom-control-input"
                        required
                      />
                      <label class="custom-control-label" for="recomendarSi"
                        >Sí</label
                      >
                    </div>
                    <div
                      class="custom-control custom-radio custom-control-inline"
                    >
                      <input
                        type="radio"
                        id="recomendarNo"
                        name="recomendar_servicio"
                        v-model="form.recomienda_servicio"
                        :value="false"
                        class="custom-control-input"
                      />
                      <label class="custom-control-label" for="recomendarNo"
                        >No</label
                      >
                    </div>
                  </div>

                  <div class="form-group mb-4">
                    <p class="font-weight-bold">
                      ¿Qué otros tipos de servicios serían de su interés?
                    </p>
                    <input
                      v-model="form.otros_servicios_interes"
                      type="text"
                      class="form-control"
                    />
                  </div>

                  <div class="form-group mb-4">
                    <p class="font-weight-bold">
                      ¿Por qué medio se enteró de nuestros servicios?
                    </p>
                    <div class="row mt-2">
                      <div
                        v-for="(label, val) in medios"
                        :key="val"
                        class="col-sm-6 col-md-4 mb-2"
                      >
                        <div class="custom-control custom-radio">
                          <input
                            type="radio"
                            :id="'medio' + val"
                            name="fuente_conocimiento"
                            v-model="form.fuente_conocimiento"
                            :value="val"
                            class="custom-control-input"
                            required
                          />
                          <label
                            class="custom-control-label"
                            :for="'medio' + val"
                            >{{ label }}</label
                          >
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="form.fuente_conocimiento === 'otro'"
                      class="form-group mt-3 mb-0"
                    >
                      <label class="font-weight-bold" for="fuenteConocimientoOtro">
                        ¿Dónde se enteró de nuestros servicios?
                      </label>
                      <input
                        id="fuenteConocimientoOtro"
                        v-model="form.fuente_conocimiento_otros"
                        type="text"
                        class="form-control"
                        placeholder="Especifique el medio"
                        maxlength="100"
                      />
                    </div>
                  </div>

                  <div class="form-group">
                    <p class="font-weight-bold">Sugerencias, dudas o quejas</p>
                    <textarea
                      v-model="form.comentarios"
                      class="form-control"
                      rows="4"
                      placeholder="Escriba aquí sus comentarios..."
                    ></textarea>
                  </div>
                </section>

                <div class="text-right border-top pt-4">
                  <button
                    type="submit"
                    class="btn btn-primary-custom btn-lg px-5 shadow-sm"
                    :disabled="isSubmitting"
                  >
                    Enviar Encuesta
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosInstance from "../../services/axiosInstance";
export default {
  name: "EncGeneral",
  data() {
    return {
      form: this.getInitialFormData(),
      labelsRating: ["Pésimo", "Malo", "Regular", "Bueno", "Excelente"],
      portalExperienceOptions: [
        { label: "Pésimo", icon: "fas fa-sad-tear" },
        { label: "Malo", icon: "fas fa-frown" },
        { label: "Regular", icon: "fas fa-meh" },
        { label: "Bueno", icon: "fas fa-smile" },
        { label: "Excelente", icon: "fas fa-grin-stars" },
      ],
      opcionesServicio: [
        { id: 1, nombre: "Elaboración del Plan Interno de Protección Civil" },
        {
          id: 2,
          nombre:
            "Dictaminación y servicios para recipientes sujetos a presión y calderas (NOM-020-STPS-2011)",
        },
        {
          id: 3,
          nombre: "Servicios de consultoría de seguridad e higiene laboral",
        },
        { id: 4, nombre: "Servicios de consultoría ambiental" },
      ],
      aspectos: {
        cotizacion: "Cotización solicitada",
        programacion: "Programación para atender el servicio",
        imagen: "Presentación e imagen del personal",
        atencion: "Atención y seguimiento",
        expediente: "Contenido del expediente",
        resultados: "Descripción de resultados",
        tiempo: "Tiempo de entrega",
      },
      medios: {
        recomendaciones: "Recomendaciones",
        redes: "Redes sociales",
        web: "Página web",
        ema: "Portal EMA",
        dependencias: "Portal dependencias",
        otro: "Otro",
      },
      isSubmitting: false,
      showErrors: false,
    };
  },
  computed: {
    showPortalExperience() {
      return this.form.servicio_evaluado.includes(1);
    },
  },
  created() {
    const { forms, empresa } = this.$route.query;

    if (empresa) {
      this.form.empresa = decodeURIComponent(empresa);
    }

    if (forms) {
      this.googleFormsUrl = decodeURIComponent(forms);
    }
  },
  methods: {
    async enviarEncuesta() {
      if (this.isSubmitting) return;
      this.showErrors = true;
      if (this.form.servicio_evaluado.length === 0) {
        this.$nextTick(() => {
          this.$refs.errorServicios?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        });
        return;
      }

      try {
        this.isSubmitting = true;
        await axiosInstance.post("/encuesta/enviar", this.form);

        const urlParaDescarga = this.googleFormsUrl || null;

        this.$router.push({
          name: "enconfirmacion",
          params: { googleFormsUrl: urlParaDescarga },
        });
      } catch (error) {
        console.error("Error al enviar:", error.response.data);
      } finally {
        this.isSubmitting = false;
      }
    },
    getInitialFormData() {
      return {
        empresa: "",
        nombre: "",
        puesto: "",
        servicio_evaluado: [],
        rating_cotizacion: null,
        rating_programacion: null,
        rating_imagen: null,
        rating_atencion: null,
        rating_expediente: null,
        rating_resultados: null,
        rating_tiempo: null,
        portal_experiencia: null,
        portal_experiencia_comentarios: "",
        recomienda_servicio: null,
        otros_servicios_interes: "",
        fuente_conocimiento: "",
        fuente_conocimiento_otros: "",
        comentarios: "",
      };
    },
  },
};
</script>

<style scoped>
.header-image {
  height: 400px;
  background-size: cover;
  background-position: center;
}

.border-left-primary-custom {
  border-left: 5px solid #136dec;
}

.btn-primary-custom {
  background-color: #136dec;
  border-color: #136dec;
  color: white;
}

.btn-primary-custom:hover {
  background-color: #0e56b9;
  border-color: #0e56b9;
  color: white;
}

/* Personalización para que los radios de Bootstrap usen tu color primary */
.custom-control-input:checked ~ .custom-control-label::before {
  border-color: #136dec;
  background-color: #136dec;
}

.font-weight-medium {
  font-weight: 500;
}

.rating-group {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
}

.rating-option {
  position: relative;
}

.rating-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.rating-label {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 12px 14px;
  border: 1px solid #d7e3f9;
  border-radius: 10px;
  background: #f8fbff;
  color: #0f2f68;
  font-weight: 600;
  transition: all 0.18s ease;
  cursor: pointer;
  min-height: 48px;
  gap: 8px;
}

.rating-label:hover {
  border-color: #136dec;
  box-shadow: 0 6px 18px rgba(19, 109, 236, 0.18);
  transform: translateY(-1px);
}

.rating-input:focus + .rating-label {
  outline: 2px solid rgba(19, 109, 236, 0.3);
  outline-offset: 2px;
}

.rating-input:checked + .rating-label {
  background: #136dec;
  color: #fff;
  border-color: #136dec;
  box-shadow: 0 8px 18px rgba(19, 109, 236, 0.3);
}

.rating-icon {
  font-size: 1.1rem;
}

@media (max-width: 576px) {
  .rating-group {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
